const SET_THEME = 'SET_THEME';
export default SET_THEME;
